import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { NonAuthRoutes, RouteParamsTypes, Modules, AuthRoutes } from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import ChangePassword from '../modules/my/changePassword';
import Profile from '../modules/my/profile';

const My: React.FC = () => {
  return (
    <Routes>
      <Route
        path={AuthRoutes.changePassword}
        element={<ProtectedRoute component={ChangePassword} />}
      />
      <Route path={AuthRoutes.profile} element={<ProtectedRoute component={Profile} />} />
      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default My;
